import React from 'react';
import { useRoutes } from 'react-router-dom';

import PrivateRoute from './PrivateRoute';
import PublicRoute from './PuplicRoute';

const Dashboard = React.lazy(() => import('../pages/Dashboard'));
const Devices = React.lazy(() => import('../pages/Devices'));
const DevicesDetails = React.lazy(() => import('../pages/DevicesDetails'));
const Login = React.lazy(() => import('../pages/Login'));
const Register = React.lazy(() => import('../pages/Register'));
const PendingConfirmation = React.lazy(() => import('../pages/PendingConfirmation'));
const Home = React.lazy(() => import('../pages/Home'));
const Logout = React.lazy(() => import('../pages/Logout'));
const User = React.lazy(() => import('../pages/User/index'));
const AuthGoogleCallback = React.lazy(() => import('../pages/AuthGoogleCallback'));
const NotFound = React.lazy(() => import('../pages/NotFound'));

const Routes = () => {
  const routes = useRoutes([
    {
      path: '/',
      element: <Home />,
    },
    {
      path: '/login',
      element: (
        <PublicRoute>
          <Login />
        </PublicRoute>
      ),
    },
    {
      path: '/auth/google/callback',
      element: (
        <PublicRoute>
          <AuthGoogleCallback />
        </PublicRoute>
      ),
    },
    {
      path: '/register',
      element: (
        <PublicRoute>
          <Register />
        </PublicRoute>
      ),
    },
    {
      path: '/confirm-email',
      element: (
        <PublicRoute>
          <PendingConfirmation />
        </PublicRoute>
      ),
    },
    {
      path: '/devices',
      element: (
        <PrivateRoute>
          <Devices />
        </PrivateRoute>
      ),
    },
    {
      path: '/devices/:id/view',
      element: (
        <PrivateRoute>
          <DevicesDetails />
        </PrivateRoute>
      ),
    },
    {
      path: '/devices/:id/edit',
      element: (
        <PrivateRoute>
          <DevicesDetails />
        </PrivateRoute>
      ),
    },
    {
      path: '/devices/:id/dashboard',
      element: (
        <PrivateRoute>
          <Dashboard />
        </PrivateRoute>
      ),
    },
    {
      path: '/logout',
      element: (
        <PrivateRoute>
          <Logout />
        </PrivateRoute>
      ),
    },
    {
      path: '/User/:tab',
      element: (
        <PrivateRoute>
          <User />
        </PrivateRoute>
      ),
    },
    {
      path: '*',
      element: <NotFound />,
    },
    {
      path: '/dashboard',
      element: (
        <PrivateRoute>
          <Dashboard />
        </PrivateRoute>
      ),
    },
  ]);

  return routes;
};

export default Routes;
